import type { IconSvgObject } from './types';

const RussianRubleIcon: IconSvgObject = [
  ["path", { d: "M14 3H13C11.1144 3 10.1716 3 9.58579 3.58579C9 4.17157 9 5.11438 9 7V11H14C16.2091 11 18 9.20914 18 7C18 4.79086 16.2091 3 14 3Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9 11V21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M6 11H9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M6 15H14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default RussianRubleIcon;
